'use client';

import App from 'app/index';

export default App;
